import { ReactElement, useState } from 'react';
import { Loader } from '~/components';
import { colors } from '~/styles/colors';
import { ControlButton, ControlButtonIcon } from '../../styles';
import img_schedule from '~/assets/img/cool_ico/schedule.svg';
import { useTranslation } from 'react-i18next';

interface ButtonShowScheduleProps {
  onClick: () => void;
  loading: boolean;
  status?: string;
}

export function ButtonShowSchedule({
  loading,
  onClick,
  status,
}: Readonly<ButtonShowScheduleProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <ControlButton
      onClick={onClick}
      disabled={loading}
    >
      {loading
        ? <Loader size="small" />
        : (
          <ControlButtonIcon
            alt={t('programacao')}
            status={status}
            src={img_schedule}
          />
        )}
      <span style={{
        fontWeight: 'bold',
        color: colors.Blue300,
        fontSize: '12px',
      }}
      >
        {t('verProgramacoes')}
      </span>
    </ControlButton>
  );
}
